import { Component, Input, OnInit } from '@angular/core';
import { SharedHttpService } from '../../services/shared-http.service';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';
 
@Component({
  selector: 'app-suggestion-decision',
  templateUrl: './suggestion-decision.component.html',
  styleUrls: ['./suggestion-decision.component.scss']
})
export class SuggestionDecisionComponent implements OnInit {
  roleId: any;
  @Input() loadDataFP: Observable<any>;

  constructor(public sharedservice: SharedHttpService,public caseService : CaseService) {
    this.roleId = this.sharedservice.CurrentUserRoleId;

   }

  SuggestionDecision: any;
  caseObject: any;

  ngOnInit(): void {    
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
this.loadData();
      }, 100);

  });   
  }



  loadData() {
        this.caseObject = this.caseService.getCaseData();
        this.SuggestionDecision = this.caseObject.suggestedDecision;

    }



    saveSuggestionDecision() {
      this.sharedservice.post("api/Case/ModifiySuggestedDecision", {
          "suggestedDecision": this.SuggestionDecision,
          "caseId": this.caseObject.caseId

      }).subscribe((response) => {                       
          
          this.sharedservice.get(`api/Case/GetCaseDetails?ecaseId=${this.caseObject.eCaseId}`).subscribe((res) => {
              console.log("CaseDetails", res);
              this.caseService.setCaseData(res);
          });
  
          this.sharedservice.showSuccessKey('CreatedSuccessfully');
      },
        (error) => {                              
          console.error('error')
          this.sharedservice.showErrorKey('Notsaved')
     
        });
    
  }

}
